<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header">
        <h3>{{movimiento.denominacion}}</h3>
        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <ul class="w-100 list-group list-group-flush mb-3" v-if="movimiento.detalles.length > 0">
          <li
            class="list-group-item"
            v-for="(detalle, i) in movimiento.detalles"
            :key="i"
          >
            <div class="widget-content p-0">
              <div class="widget-content-wrapper row">
                <div class="widget-content-left col-sm-9 col-12">
                  <h5 class="widget-heading text-primary opacity-10">{{detalle.articulo.descripcion}}</h5>
                  <div class="widget-subheading opacity-10 row">
                    <h5 class="col-sm-auto col-12">
                      Precio:
                      <b class="text-success">${{detalle.importe | numFormat('0,0.00')}}</b>
                    </h5>
                    <h5 class="col-sm-auto col-12">
                      Cantidad:
                      <b class="text-alternate">{{detalle.cantidad}}</b>
                    </h5>
                  </div>
                </div>
                <div class="widget-content-right col-sm-3 text-right">
                  <div class="widget-numbers text-danger">
                    <span class="count-up-wrapper">${{detalle.total | numFormat('0,0.00')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger" @click="cerrarModal">Cerrar</button>
      </div>
    </div>
  </my-modal>
</template>
<script>
import MyModal from "@/components/layouts/MyModal";
export default {
  name: "ModalDetalleComprobante",
  components: {
    MyModal,
  },
  created() {
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal();
      next(false);
    });

    this.$once("hook:destroyed", () => {
      unregisterRouterGuard();
    });
  },
  data() {
    return {
      loading: false,
    };
  },
  props: ["movimiento"],
  methods: {
    cerrarModal() {
      this.$emit("cerrarDetalleComprobante");
    },
  },
};
</script>